export enum RecurringType {
  NonRecurring,
  EveryWeek,
  EveryMonthOnDate,
  EveryMonthOnWeekday,
}
